module.exports = __webpack_public_path__ + "static/media/ronnievisser.c560bc0b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/ronnievisser.webp
// module id = 826
// module chunks = 0